const linkData = [
  {
    id: 1,
    name: "Why Me",
    url: "/#why_me",
  },
  {
    id: 2,
    name: "Experience",
    url: "/#timeline",
  },
  {
    id: 3,
    name: "Projects",
    url: "/#projects",
  },
  {
    id: 4,
    name: "Contact",
    url: "/#contact",
  },
  {
    id: 5,
    name: "Blog",
    url: "https://blog.guilhermegr.com"
  }
]

export default linkData
